export default "__VITE_ASSET__DFOdeOzZ__"